import habitat from 'preact-habitat'
import ready from 'document-ready'

import Widget from './components/Widget'

const appointmentSearch = habitat(Widget)

ready(function () {
  appointmentSearch.render({
    selector: '.js-appointment-search'
  })
})
